import AiStudioResource from 'flow/api/aistudio';
import { AiStudioAuthorizationCodeResponse } from '../types/AiStudioTypes';

export const hasUserAccessToAiStudio = () =>
    new Promise<boolean>((resolve, reject) =>
        AiStudioResource.hasUserAccessToAiStudio({
            onResult: () => resolve(true),
            onError: reject,
            onClientError: reject,
        }),
    );

export const getAuthorizationCode = () =>
    new Promise<AiStudioAuthorizationCodeResponse>((resolve, reject) =>
        AiStudioResource.getAuthorizationCode({
            onResult: resolve,
            onError: reject,
            onClientError: reject,
        }),
    );
